// extracted by mini-css-extract-plugin
export default {"useLocation":"input-search-autocomplete__useLocation___2rh53","inputSearchContainer":"input-search-autocomplete__inputSearchContainer___3laIv"};